// Common input styles for consistent styling across the application

export const basePressableStyles = "w-full border border-[#3c62ec] rounded-lg shadow-md shadow-[#3c62ec]/10 hover:shadow-lg hover:shadow-[#3c62ec]/10 transition-shadow duration-200";